import { Typographies } from '@/theme';
import { TableCell, styled, TableCellBaseProps } from '@mui/material';

interface JTableCellStyledProps extends TableCellBaseProps {
  isbold: boolean;
}

export const JTableCellStyled = styled(TableCell)<JTableCellStyledProps>(
  ({ theme, isbold }) => ({
    border: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.dark.dark_2,
    fontWeight: isbold
      ? Typographies.FONT_WEIGHT_H2
      : Typographies.FONT_WEIGHT_BODY,
  }),
);
